import JustValidate from 'just-validate';
export const addFields = ($form, $fields) => {
  const $radioGroups = $form.querySelectorAll('.radio-group');
  $fields.forEach($field => {
    const {
      powermailErrorMessage,
      powermailRequiredMessage
    } = $field.dataset;
    const id = $field.getAttribute('id');
    const type = $field.getAttribute('type');
    const {
      pattern
    } = $field;
    const isHidden = $field.closest('.d-none');
    if (isHidden) return;
    const rules = [{
      rule: 'required',
      errorMessage: powermailRequiredMessage
    }];
    if (type === 'email') {
      rules.push({
        rule: type,
        errorMessage: powermailErrorMessage
      });
    }
    if (pattern) {
      rules.push({
        rule: 'customRegexp',
        value: pattern,
        errorMessage: powermailErrorMessage
      });
    }
    if (!id) return;
    $form.validate.addField(`#${id}`, rules);
    if (id === 'sfrpasswordRepeat') {
      $form.validate.addField('#sfrpasswordRepeat', [{
        validator: (value, fields) => {
          if (fields['#sfrpassword'] && fields['#sfrpassword'].elem) {
            const repeatPasswordValue = fields['#sfrpassword'].elem.value;
            return value === repeatPasswordValue;
          }
          return true;
        },
        errorMessage: powermailErrorMessage || 'Passwords should be the same'
      }]);
    }
    if (!$radioGroups.length) return;
    $radioGroups.forEach(radioGroup => {
      const groupId = radioGroup.getAttribute('id');
      if (!groupId) return;
      $form.validate.addRequiredGroup(`#${groupId}`);
    });
  });
};
const handleStepForm = $form => {
  const $btnSteps = $form.querySelectorAll('.js-btn-steps');
  const $formPages = $form.querySelectorAll('.powermail_fieldset');
  let activeStep = 0;
  const togglePages = function () {
    let step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    $formPages.forEach(($page, index) => {
      $page.classList.toggle('d-none', index !== step);
      $page.classList.toggle('powermail_fieldset_active', index === step);
      activeStep = step;
    });
  };
  const handleFormSteps = e => {
    const {
      target
    } = e;
    const step = target.getAttribute('data-powermail-morestep-show');
    const $activePage = $form.querySelector('.powermail_fieldset_active');
    const $fields = $activePage.querySelectorAll('input:required, select:required, textarea:required');
    $form.validate.fields = {};
    addFields($form, $fields);
    $form.validate.revalidate().then(isValid => {
      if (isValid || step < activeStep) togglePages(parseInt(step, 10));
    });
  };
  togglePages();
  $btnSteps.forEach($btn => {
    $btn.addEventListener('click', handleFormSteps);
  });
};
export const formValidate = $form => {
  $form.validate = new JustValidate($form, {
    errorLabelStyle: {},
    focusInvalidField: true
  });
  $form.validate.onSuccess(e => {
    if (e) {
      $form.classList.add('loading');
      e.target.submit();
    }
  });
  const $fields = $form.querySelectorAll('input:required, select:required, textarea:required');
  addFields($form, $fields);
  window.addEventListener('message', event => {
    if (event.origin.includes('cloudflare') && event.data.event === 'init') {
      const $cloudflareWrapper = $form.querySelector('.cf-turnstile');
      const {
        powermailRequiredMessage
      } = $cloudflareWrapper.dataset;
      const $captchaField = $cloudflareWrapper.querySelector('[name="cf-turnstile-response"]');
      $form.validate.addField($captchaField, [{
        rule: 'required',
        errorMessage: powermailRequiredMessage
      }], {
        errorsContainer: '.powermail_fieldwrap_type_recaptcha'
      });
    }
  });
  if ($form.classList.contains('powermail_morestep')) handleStepForm($form);
};
const formsValidation = function () {
  let $forms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelectorAll('.powermail_form');
  if (!$forms.length) return;
  $forms.forEach($form => {
    if ($form.validate) return;
    formValidate($form);
  });
};
export default formsValidation;